import API from './fetchAPI';

export const fetchGraphDataByAge = async (transformedData) => {

  const response = await fetch('/plot/age_bar/', { // 'http://127.0.0.1:7000/api/plot/age_bar/',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(transformedData)
  });
  return response.json();
};

export const fetchGraphDataByCategory = async (transformedData) => {

  const response = await fetch('/plot/bar', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(transformedData)
  });
  return response.json();
};

// Routed through the HGQN backend (rather than the browser calling the
// visualiser directly) so the backend can attach the admin token needed to
// reveal case IDs in the UMAP response, without ever exposing that secret to
// frontend code.
export const fetchGraphDataUmap = async (transformedData) => {
  return API.post('/api/labs/umap', { params: transformedData });
};

export const fetchGraphTrend = async (cases, resolution = 'quarter') => {
  const response = await fetch('/plot/trend/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cases, resolution })
  });
  return response.json(); // expect a JSON object (not a JSON string)
};

